import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { EllipsisDiv } from '@/styles/style';

interface Props {
  customer: CustomerT;
  onClick: () => void;
}

const ContactShortItem = ({ customer, onClick }: Props) => {
  const color = useColor();
  return (
    <Wrapper a="center" onClick={onClick}>
      <EllipsisDiv className="full-name">
        <Typo type="label2" weight="m" color={color.gray700}>
          {customer.name}
        </Typo>
      </EllipsisDiv>
      <EllipsisDiv className="position">
        <Typo type="label2" color={color.gray600}>
          {customer.job_function}
        </Typo>
      </EllipsisDiv>
      <EllipsisDiv className="email">
        <Typo type="label2" color={color.gray600}>
          {customer.email}
        </Typo>
      </EllipsisDiv>
      <div className="feedback-num">
        <Typo type="label2" color={color.gray600}>
          {customer?.feedback_count || 0}
        </Typo>
      </div>
    </Wrapper>
  );
};

export default ContactShortItem;

const Wrapper = styled(Flex)`
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  padding: 12px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryAlpha(0.02)};
  }

  .full-name {
    width: 160px;
  }

  .position {
    width: 100px;
  }

  .email {
    width: 160px;
  }

  .feedback-num {
    width: 50px;
    display: flex;
    justify-content: flex-end;
    width: 50px;
  }
`;
